export default __webpack_public_path__ + "locales/ru/VersionHistory.json?hash=c35dc836e16f485c29feea9a866b76c3";